import { toast } from "react-toastify";
import api from "./api/api";

type MeetingMinutePayload = {
  held_at: string;
  responsible_id: number;
  content: string;
};

const validatePayload = (payload: any) => {
  const { mes, ano } = payload;
  if (
    (mes.length > 0 && ano.length === 0) ||
    (ano.length > 0 && mes.length === 0)
  ) {
    toast.error("Você deve selecionar o mês e o ano juntos.");
    return false;
  }
  if (mes.length > 0 && ano.length > 0) {
    payload.date = true;
  }
  const filteredPayload = Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== "" && value !== false;
    }),
  );

  return filteredPayload;
};

const serviceMeetings = {
  getMeetingSearch: async (search: any) => {
    try {
      const res = await api.get(
        `/reunions?page=1&perPage=999&${search && `s=${search}`}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getMeeting: async (payload: any) => {
    try {
      const res = await api.post(
        `/reunions/allReunions`,
        validatePayload(payload),
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getMyMeeting: async (payload: any = {}) => {
    try {
      const res = await api.post(`/reunions/myReunions`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  newMeeting: async (payload: any) => {
    try {
      const res = await api.post(`/reunions`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  editMeeting: async (id: any, payload: any) => {
    try {
      const res = await api.put(`/reunions/${id}`, payload, { timeout: 30000 });
      return res;
    } catch (error: any) {
      if (error.response) return error.response;
      throw error;
    }
  },
  checkRoomAvailability: async (payload: any) => {
    try {
      const res = await api.post(`/reunions/rooms/check`, payload, {
        timeout: 10000,
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getRoomOccupancy: async (payload: any) => {
    try {
      const res = await api.post(`/reunions/rooms/occupancy`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getMeetingRooms: async (params: any = {}) => {
    try {
      const res = await api.get(`/meeting-rooms`, { params });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  createMeetingRoom: async (payload: any) => {
    try {
      const res = await api.post(`/meeting-rooms`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateMeetingRoom: async (id: number | string, payload: any) => {
    try {
      const res = await api.put(`/meeting-rooms/${id}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteMeetingRoom: async (id: number | string) => {
    try {
      const res = await api.delete(`/meeting-rooms/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  uploadMeetingRoomImage: async (file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await api.post(`/files/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteMeeting: async (id: any) => {
    try {
      const res = await api.delete(`/reunions/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getTypesReunions: async () => {
    try {
      const res = await api.get(`/reunions/types/all`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getMeetingById: async (id: number | string) => {
    try {
      const res = await api.get(`/reunions/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getMinutes: async (reunionId: number | string) => {
    try {
      return await api.get(`/reunions/${reunionId}/minutes`);
    } catch (error: any) {
      return error.response;
    }
  },
  createMinute: async (
    reunionId: number | string,
    payload: MeetingMinutePayload,
  ) => {
    try {
      return await api.post(`/reunions/${reunionId}/minutes`, payload);
    } catch (error: any) {
      return error.response;
    }
  },
  updateMinute: async (
    reunionId: number | string,
    minuteId: number | string,
    payload: MeetingMinutePayload,
  ) => {
    try {
      return await api.put(
        `/reunions/${reunionId}/minutes/${minuteId}`,
        payload,
      );
    } catch (error: any) {
      return error.response;
    }
  },
};

export default serviceMeetings;
